import React from 'react';

import { PageReactDataTable } from '@metarouter-private/mr-mui';

import useAnalyticsFilesTable from './useAnalyticsFilesTable';

export default function AnalyticsFilesTable() {
  const tableProps = useAnalyticsFilesTable();

  return <PageReactDataTable {...tableProps} />;
}
